<script setup lang="ts">
/**
 * UI-kit component
 * Category: Headers
 * Name: HeaderLink
 * FIGMA: https://www.figma.com/design/NgI2cVJkWODrgnOBHO3Zed/Strapi-Builder--DS-?node-id=3089-1104
 *
 * A single item in a header menu column: Body/L pill (min 164 wide, radius/12,
 * px space/16 py space/10) that is plain text at rest and a surface/brand tinted
 * pill on hover/press. The label wraps to 2 lines, then truncates with an
 * ellipsis. Optional sunshine/400 badge at the row end keeps full saturation in
 * every state; disabled dims the label only and drops the anchor.
 * Local implementation of the Figma DS component missing from @brighterly/lib-lumee-ui.
 */
// types
import type { HeaderLinkProps } from '../types/interfaces'

defineOptions({
  name: 'HeaderLink',
})

withDefaults(defineProps<HeaderLinkProps>(), {
  badgeLabel: '',
  disabled: false,
})
</script>

<template>
  <component
    :is="disabled ? 'span' : 'a'"
    class="header-link"
    :class="{ 'header-link--disabled': disabled }"
    :href="disabled ? undefined : url"
    :aria-disabled="disabled ? 'true' : undefined"
  >
    <span class="header-link__label btly-text-body-l">{{ label }}</span>
    <span
      v-if="badgeLabel"
      class="header-link__badge btly-text-label-s"
    >{{ badgeLabel }}</span>
  </component>
</template>

<style lang="scss" scoped src="../styles/_header-link.scss" />
